/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ActivateApiAccessForCurrentRetailerCommand,
  ApiAccess,
  UpdatePublicationUrlsForCurrentRetailerCommand,
} from '../models/index';
import {
    ActivateApiAccessForCurrentRetailerCommandFromJSON,
    ActivateApiAccessForCurrentRetailerCommandToJSON,
    ApiAccessFromJSON,
    ApiAccessToJSON,
    UpdatePublicationUrlsForCurrentRetailerCommandFromJSON,
    UpdatePublicationUrlsForCurrentRetailerCommandToJSON,
} from '../models/index';

export interface ActivateApiAccessRequest {
    activateApiAccessForCurrentRetailerCommand: ActivateApiAccessForCurrentRetailerCommand;
}

export interface UpdatePublicationUrlsRequest {
    updatePublicationUrlsForCurrentRetailerCommand: UpdatePublicationUrlsForCurrentRetailerCommand;
}

/**
 * 
 */
export class ApiAccessResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for activateApiAccess without sending the request
     */
    async activateApiAccessRequestOpts(requestParameters: ActivateApiAccessRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['activateApiAccessForCurrentRetailerCommand'] == null) {
            throw new runtime.RequiredError(
                'activateApiAccessForCurrentRetailerCommand',
                'Required parameter "activateApiAccessForCurrentRetailerCommand" was null or undefined when calling activateApiAccess().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/ui/retailerapi/access/activate`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ActivateApiAccessForCurrentRetailerCommandToJSON(requestParameters['activateApiAccessForCurrentRetailerCommand']),
        };
    }

    /**
     */
    async activateApiAccessRaw(requestParameters: ActivateApiAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiAccess>> {
        const requestOptions = await this.activateApiAccessRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiAccessFromJSON(jsonValue));
    }

    /**
     */
    async activateApiAccess(requestParameters: ActivateApiAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiAccess> {
        const response = await this.activateApiAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getApiAccess without sending the request
     */
    async getApiAccessRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/retailerapi/access`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getApiAccessRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiAccess>> {
        const requestOptions = await this.getApiAccessRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiAccessFromJSON(jsonValue));
    }

    /**
     */
    async getApiAccess(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiAccess> {
        const response = await this.getApiAccessRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updatePublicationUrls without sending the request
     */
    async updatePublicationUrlsRequestOpts(requestParameters: UpdatePublicationUrlsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['updatePublicationUrlsForCurrentRetailerCommand'] == null) {
            throw new runtime.RequiredError(
                'updatePublicationUrlsForCurrentRetailerCommand',
                'Required parameter "updatePublicationUrlsForCurrentRetailerCommand" was null or undefined when calling updatePublicationUrls().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/ui/retailerapi/access`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePublicationUrlsForCurrentRetailerCommandToJSON(requestParameters['updatePublicationUrlsForCurrentRetailerCommand']),
        };
    }

    /**
     */
    async updatePublicationUrlsRaw(requestParameters: UpdatePublicationUrlsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiAccess>> {
        const requestOptions = await this.updatePublicationUrlsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiAccessFromJSON(jsonValue));
    }

    /**
     */
    async updatePublicationUrls(requestParameters: UpdatePublicationUrlsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiAccess> {
        const response = await this.updatePublicationUrlsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
